import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import * as api from "../../api";

import Loader from "react-loader-spinner";
import {
  updateDashboardForm,
  fetchRepairReasons,
  fetchRepairReasonsSelect,
} from "../../ducks/redux/actions/dashboardReducer.actions";
import RepairReason2 from "./index2";
import "./index.scss";

import { RouteComponentProps } from "react-router-dom";
import Button from "../../storybook/Button";
import ExitModalAndSave from "../Modal/ExitModalAndSave";
import { CurrentRepair } from "../../models/Repair/Repair";
import { PremisesTypeId } from "../../models/Customer/Premises";
import { Address, CustomerName } from "../../models/Customer";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import { workOrderRepairObject } from "../../ducks/redux/actions/getAddress";
import BackModal from "../Modal/BackModal";
import {
  userChosenSupplementaryQuestions,
  userChosenEmergencyQuestion,
  userChosenDuplicateQuestion,
  userChosenAdditionalDescription,
  userChosenVandalismQuestion,
  userChosenVandalismAdditionalInformation,
  userChosenCovidQuestion,
  userChosenVulnerabilityQuestion,
  userChosenVulnerabilityAdditionalInformation,
  userChosenContactDetails,
  userChosenContactPhone,
  userChosenContactName,
  resumeDraftRepair,
  userCreatedNewRepair,
  userChosenResumeRepair,
  userChosenRepairLocationId,
  userChosenHighLevelDescription,
  showFooter,
  DMCChecksavedAnswer
} from "../../ducks/redux/actions/userChoices";
import { RemoveAllDMCData } from "../../ducks/redux/actions/FinancialReferral";
import { RepairPriorityCode } from "../../models/Repair/RepairPriority";

interface RepairReasonProps extends RouteComponentProps<any> { }

const RepairReason: React.FC<RepairReasonProps> = (props) => {
  const dispatch = useDispatch();

  enum RepairReportingMethods {
    "Telephone" = 1,
    "Email" = 2,
    "Social media" = 3,
    "Customer Self-Serve" = 4,
  }
  const [selectedreportingMethod, setSelectedreportingMethod] = useState(
    "Customer Self-Serve"
  );
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [repairLocation, setRepairLocation] = useState("");

  const [isDisabled, setButtonDisabled] = useState(true);
  const [chosenHL, setChosenHL] = useState("");
  const [locatioAlert, setLocatioAlert] = useState<string[]>([]);
  const [closeAfterSaving, setCloseAfterSaving] = useState(false);
  let alertMstArray: any[] = [];
  let SaveandExitFlag = false;
  const addresses = useSelector(
    (state: any) => state.addresses?.customerassociatedassets
  );

  const fetchedRepairReasons = useSelector(
    (state: any) => state.dashboardReducer.formState?.fetchedRepairReasons
  );

  const userTypedRepairReasons = useSelector(
    (state: any) => state.dashboardReducer.formState?.userTypedRepairReasons
  );

  const userChosenPropertyType = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenPropertyType
  );

  const userChosenRepairLocationIdValue = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenRepairLocationId
  );

  const selectedRepairReasonObject = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.selectedRepairReasonObject
  );
  const userChosenHighLevelDescriptionBackButton = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenHighLevelDescription
  );
  const userChosenUPRN = useSelector(
    (state: any) => state.userChoicesReducer.userChosenUPRN
  );

  const tenanciesData = useSelector(
    (state: any) => state.addresses.customertenancies
  );
  const customerDetails = useSelector(
    (state: any) => state.addresses.saveCustomerDetails
  );

  const assetId = useSelector(
    (state: any) => state?.dashboardReducer?.formState?.customerID?.assetId
  );

  const EditState = useSelector(
    (state: any) => state.userChoicesReducer?.isEditState
  );

  const selectedproperty = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenPropertyType
  );

  const customerID = useSelector((state: any) => state.addresses?.customerid);

  const resumeDraftRepairVal = useSelector(
    (state: any) => state.userChoicesReducer?.resumeDraftRepair
  );
  const userResumeDraftDataCache = useSelector(
    (state: any) => state.userChoicesReducer.userResumeDraftDataCache
  );

  const workOrderObject = useSelector(
    (state: any) => state.addresses.workOrderRepair
  );
  const sordamp = useSelector((state: any) => state.financialReferralReducer?.sordamp);

  const isCatalyst = useSelector(
    (state: any) => state.userChoicesReducer?.isCatalystCustomer
  );

  const eligibilityResponseObject = useSelector(
    (state: any) =>
      state?.dashboardReducer?.formState?.eligibilityResponseObject
  );
  const userChosenSOR = useSelector(
    (state: any) => state.userChoicesReducer.userChosenSOR
  );
  const repairPriority = useSelector(
    (state: any) => state.userChoicesReducer?.repairPriority
  );
  const selectSorValue = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenSOR
  );
  const isDmcEnabled = useSelector(
    (state: any) => state?.addresses?.isDMCEnabledtoggleValue
  );

  const workOrderRepair = new CurrentRepair();
  enum RepairCauseId {
    "General Wear and Tear" = 1,
    "Vandalism or Damage" = 4,
  }
  const _premisesTypeId: any =
    PremisesTypeId[selectedproperty as keyof typeof PremisesTypeId];
  workOrderRepair.repairReason = selectedRepairReasonObject?.[0]?.description;
  workOrderRepair.description = selectedRepairReasonObject?.[0]?.description;

  workOrderRepair.premisesId = assetId;
  if (selectedproperty === "Divided Block") {
    workOrderRepair.premisesTypeId = "5";
  } else {
    workOrderRepair.premisesTypeId = _premisesTypeId;
  }
  workOrderRepair.customerIdentifier = customerID;


  workOrderRepair.premisesUniqueReference = userChosenUPRN;
  const _address = new Address();
  _address.addressLine1 =
    customerDetails?.addresses?.postalAddresses[0]?.addressLine1;
  _address.addressLine2 =
    customerDetails?.addresses?.postalAddresses[0]?.addressLine2;
  _address.addressLine3 =
    customerDetails?.addresses?.postalAddresses[0]?.addressLine3;
  workOrderRepair.premisesAddress = _address;
  workOrderRepair.sorCode = selectedRepairReasonObject?.[0]?.sors[0]?.sorCode ?? userChosenSOR;
  workOrderRepair.customerName = new CustomerName({
    title: customerDetails?.person?.name?.title,
    givenName: customerDetails?.person?.name?.givenName,
    surname: customerDetails?.person?.name?.surname,
  });
  workOrderRepair.reportingMethodId =
    RepairReportingMethods[
    selectedreportingMethod as keyof typeof RepairReportingMethods
    ];
  workOrderRepair.reportingMethod = selectedreportingMethod;

  workOrderRepair.notifyAll = false;
  workOrderRepair.eTag = customerDetails?.eTag;
  workOrderRepair.eligibilityOutcomes = [];
  workOrderRepair.assetIdentifier = tenanciesData?.premisesIds;
  workOrderRepair.repairLocationId = userChosenRepairLocationIdValue;
  workOrderRepair.repairCause = "General Wear and Tear";
  workOrderRepair.priority = repairPriority;
  workOrderRepair.isEmergency = repairPriority === "EME";
  workOrderRepair.repairCauseId =
    RepairCauseId[workOrderRepair.repairCause as keyof typeof RepairCauseId];
  const _worksOrderRequest = new WorksOrderRequest(workOrderRepair);
  const woRequestParameters =
    _worksOrderRequest.createWorkOrderParameter(workOrderRepair);

  const CreateWorkOrder = async () => {
    try {
      setIsLoading(true);
      const sordampValues = sordamp?.split(",") || [];
      if (isDmcEnabled) {
        woRequestParameters.isCausingDampAndMould = sordampValues?.includes(selectSorValue);
      }
      if (!chosenHL) {
        woRequestParameters.repairReason = "";
        woRequestParameters.description = "";
      }
      if (userChosenSOR === "N/A") {
        woRequestParameters.sorCode = "NA";
        workOrderRepair.sorCode = "NA";
      }
      else {
        woRequestParameters.sorCode = userChosenSOR;
        workOrderRepair.sorCode = userChosenSOR;
      }
      woRequestParameters.isCatalyst = isCatalyst;
      woRequestParameters.isInDefect = eligibilityResponseObject?.statuses.isInDefects
      const apiResponse = await api.createWorkOrderRepair({
        ...woRequestParameters,
      });
      workOrderRepair.workProgramme = selectedRepairReasonObject?.[0]?.sors[0].workProgramme || null;
      if (apiResponse?.location.length > 0) {
        const workorderLocation = apiResponse?.location.split("/");
        workOrderRepair.id = workorderLocation[4];
        workOrderRepair.worksOrderIdentifier = workorderLocation[4];
        workOrderRepair.isCausingDampAndMould = sordampValues?.includes(selectSorValue) ? true : null;
        workOrderRepair.isCatalyst = isCatalyst;
        dispatch(workOrderRepairObject(workOrderRepair));
        dispatch(userCreatedNewRepair(workOrderRepair));
      }
      updateWODirectToNextPage();
    } catch (e) {
      console.error(e);
      dispatch(showFooter(true));
      props.history.push({
        pathname: '/repairJourneyErrorPage',
        state: { message: 'repair_Journey_Error_Message1' }
      });
    } finally {
      setIsLoading(false);
    }
  };
  const backButtonHandler = () => {
    if (!resumeDraftRepairVal) {
      dispatch(userChosenRepairLocationId(0));
      dispatch(userChosenHighLevelDescription(""));
    }
    props.history.push("/repairasset");
  };
  const UpdateWorkOrder = async () => {
    try {
      setIsLoading(true);
      const sordampValues = sordamp?.split(",") || [];
      if (workOrderObject.id.trim().length > 0 && EditState !== true) {
        workOrderObject.repairReason =
          selectedRepairReasonObject[0]?.description ?? userChosenHighLevelDescriptionBackButton;
        workOrderObject.description =
          selectedRepairReasonObject[0]?.description ?? userChosenHighLevelDescriptionBackButton;
        workOrderObject.isCausingDampAndMould = sordampValues?.includes(selectedRepairReasonObject[0]?.sors[0]?.sorCode) ? true : null;
        workOrderObject.isCatalyst = isCatalyst;
        workOrderObject.sorCode = selectedRepairReasonObject[0]?.sors[0]?.sorCode ?? userChosenSOR;
        workOrderObject.isInDefect = eligibilityResponseObject?.statuses.isInDefects;
        workOrderObject.isEmergency = repairPriority === RepairPriorityCode.Emergency
          || repairPriority === RepairPriorityCode.DampAndMouldEmergency;
        workOrderObject.reportingMethod = selectedreportingMethod;
        workOrderObject.priority = repairPriority;

        const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
        const woRequestParameters =
          _worksOrderRequest.updateWorkOrderParameter(workOrderObject);
        await api.updateWorkOrderRepair(
          woRequestParameters,
          workOrderObject.id,
          "eTag"
        );
        dispatch(workOrderRepairObject(workOrderObject));
        dispatch(userCreatedNewRepair(workOrderObject));
        updateWODirectToNextPage();
        ;
      }
      else {
        const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
        const woRequestParameters =
          _worksOrderRequest.updateWorkOrderParameter(workOrderObject);
        woRequestParameters.repairReason =
          selectedRepairReasonObject?.[0]?.description;
        woRequestParameters.description =
          selectedRepairReasonObject?.[0]?.description;
        workOrderObject.repairReason = selectedRepairReasonObject?.[0]?.description ?? userChosenHighLevelDescriptionBackButton;
        workOrderObject.description = selectedRepairReasonObject?.[0]?.description ?? userChosenHighLevelDescriptionBackButton;
        await api.updateWorkOrderRepair(
          woRequestParameters,
          workOrderObject.id,
          "eTag"
        );


        dispatch(workOrderRepairObject(workOrderObject));
        dispatch(userCreatedNewRepair(workOrderRepair));
        updateWODirectToNextPage();
      }

    } catch (e) {
      console.error(e);
      dispatch(showFooter(true));
      props.history.push({
        pathname: '/repairJourneyErrorPage',
        state: { message: 'repair_Journey_Error_Message1' }
      });
    } finally {
      setIsLoading(false);
      setButtonDisabled(false);
    }
  };

  const updateWODirectToNextPage = () => {
    if (SaveandExitFlag) {
      props.history.push("/customer360View");
    }
    else {
      props.history.push("/supplementaryquestion");
    }
  }

  useEffect(() => {
    (async function () {
      try {
        if (userTypedRepairReasons !== null && userTypedRepairReasons.length > 1) {
          const premiseType =
            userChosenPropertyType === "Block" ||
              userChosenPropertyType === "Estate" ||
              userChosenPropertyType === "Divided Block" ||
              userChosenPropertyType === "Divided block"
              ? "Communal"
              : userChosenPropertyType;
          const responsedata = await api.searchRepairReasons(
            userTypedRepairReasons,
            premiseType,
            isCatalyst
          );
          dispatch(fetchRepairReasonsSelect(responsedata));
          const extractedReasons: string[] = [];
          responsedata?.map((eachData, key) => {
            const { description } = eachData;
            extractedReasons.push(description);
          });
          dispatch(fetchRepairReasons(extractedReasons));
        }
      } catch (e) {
        console.error(e);
        dispatch(showFooter(true));
        props.history.push({
          pathname: '/repairJourneyErrorPage',
          state: { message: 'repair_Journey_Error_Message1' }
        });
      }
    })();
  }, [addresses, userTypedRepairReasons]);

  useEffect(() => {
    if (userChosenRepairLocationIdValue) {
      setRepairLocation(userChosenRepairLocationIdValue);
    }
    alertMstArray = [];
    setLocatioAlert([]);
    dispatch(userCreatedNewRepair(null));
    SaveandExitFlag = false;
  }, []);

  //redux data to check radio button selection
  const updateSelection = (e: any) => {
    dispatch(
      updateDashboardForm({
        selected: e.target.value,
      })
    );
  };
  //ends here

  let fieldsArray: any[] = [];
  addresses?.forEach((address: any) => {
    const addressValue =
      address?.addresses?.postalAddresses[0]?.formattedAddress;

    fieldsArray.push(
      <FormControlLabel
        value={addressValue}
        control={<Radio onChange={updateSelection} />}
        label={addressValue}
      />
    );
  });

  const exitButtonHandler = () => {
    props.history.push("/customer360View");
  };

  const saveDraftAndExit = () => {
    SaveandExitFlag = true;
    workOrderObject == null ? CreateWorkOrder() : UpdateWorkOrder();
  };

  const getMandatoryData = (data: any) => {
    setChosenHL(data);
  };

  const callPageHandler = () => {
    if (resumeDraftRepairVal) {
      const { repairLocationId, repairReason } = userResumeDraftDataCache;
      if (
        userChosenRepairLocationIdValue !== repairLocationId ||
        chosenHL !== repairReason
      ) {
        dispatch(resumeDraftRepair(false));
        dispatch(userChosenSupplementaryQuestions(""));
        dispatch(DMCChecksavedAnswer(""))
        dispatch(userChosenEmergencyQuestion(""));
        dispatch(userChosenDuplicateQuestion(""));
        dispatch(userChosenAdditionalDescription(""));
        dispatch(userChosenVandalismQuestion("No"));
        dispatch(userChosenVandalismAdditionalInformation(""));
        dispatch(userChosenCovidQuestion(""));
        dispatch(userChosenVulnerabilityQuestion("No"));
        dispatch(userChosenVulnerabilityAdditionalInformation(""));
        dispatch(userChosenContactDetails(""));
        dispatch(userChosenContactPhone(""));
        dispatch(userChosenContactName(""));
        dispatch(RemoveAllDMCData(null))
      }
      if (repairLocationId == "" || repairReason == "") {
        if (workOrderObject.id.trim().length > 0) {
          workOrderObject.repairLocationId = userChosenRepairLocationIdValue;
          workOrderObject.repairReason = selectedRepairReasonObject?.[0]?.description;
          workOrderObject.description = selectedRepairReasonObject?.[0]?.description;
        }
        dispatch(userChosenResumeRepair(false));
        dispatch(workOrderRepairObject(workOrderObject));
        dispatch(userCreatedNewRepair(workOrderObject));
        props.history.push("/supplementaryquestion");
        return;
      }
    }

    if (
      !chosenHL &&
      (userChosenRepairLocationIdValue == 0 ||
        userChosenRepairLocationIdValue === "No option selected global-txt")
    ) {
      alertMstArray.push(t("SSR051"));
      alertMstArray.push(t("SSR052"));
      setLocatioAlert(alertMstArray);
      return;
    } else if (
      userChosenRepairLocationIdValue == 0 ||
      userChosenRepairLocationIdValue === "No option selected global-txt"
    ) {
      alertMstArray.push(t("SSR051"));
      setLocatioAlert(alertMstArray);
      return;
    } else if (!chosenHL || (!chosenHL && userChosenRepairLocationIdValue)) {
      alertMstArray.push(t("SSR052"));
      setLocatioAlert(alertMstArray);
      return;
    }

    alertMstArray = [];
    setLocatioAlert([]);
    //logic to create/update workorder   
    (workOrderObject == null || workOrderObject == undefined) ? CreateWorkOrder() : UpdateWorkOrder();

  };

  return (
    <>
      <div id="repreason-main-div" className="padding-repair">
        <RepairReason2
          suggestions={fetchedRepairReasons}
          setButtonDisabled={setButtonDisabled}
          locatioAlert={locatioAlert}
          getMandatoryData={getMandatoryData}
          {...props}
        />
      </div>
      {isLoading && (
        <div className="pl-2">
          <Loader
            type="ThreeDots"
            color="#00BFFF"
            height={50}
            width={50}
          />
        </div>
      )
      }
      <div className="col-md-12 mt-2" id="repreason-main-btn">
        <div className="footer-back footer-actionbtn">
          <div className="ml-5 mlr-5">
            <BackModal id="reploc-backmodal" back={backButtonHandler} />
            <ExitModalAndSave
              id="repreason-exitmodal"
              exit={exitButtonHandler}
              saveDraftAndExit={saveDraftAndExit}
              closeAfterSaving={closeAfterSaving}
            />
          </div>
          <div className="mlr-5">
            <Button
              id="btn_repairreason"
              type="button"
              data-testid="btncontinue"
              name="btncontinue"
              disabled={isDisabled}
              onClick={callPageHandler}
              placeholder="btncontinue"
              value="Continue"
              className="primary-btn"
            >
              {t("continuen_button")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};
export default RepairReason;